import { withCommas } from '@common/Utils';
import { appConfig } from '@common/config';
import { numToKor } from '@common/numToKor';
import { FavoriteBtn } from '@components/FavoriteBtn';
import { getDefalutImgUrl } from '@constants/config';
import { useSetSearchParams } from '@hook/useSetSearchParams';
import { type IPriceItem } from '@interface/IItemPrice';
import classNames from 'classnames';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PriceItemStock } from './PriceItemStock';

const numFnMap: Record<string, (_num: number | undefined) => string> = {
    l2m: withCommas,
    lms: numToKor,
};

export const PriceItem = ({ it, svrid }: { it: IPriceItem; svrid: string }) => {
    const { t } = useTranslation();
    const numChangeFn = numFnMap[appConfig.service];
    const [isopen, isopenSet] = useState(false);
    const [qtity, qtitySet] = useState(it.quantity);
    const setParams = useSetSearchParams();

    return (
        <div className={classNames({ 'is-active': isopen }, 'tablerow')} data-id={it.itemId}>
            <div className="tablecell favorite">
                <FavoriteBtn itemId={it.itemId} isFav={it.favorite} type={'item'} ga360str="시세_리스트_즐겨찾기_클릭" />
            </div>
            <div className="tablecell itemname">
                <button className="btn-item" onClick={() => setParams({ detail: `item_${it.itemId}_${it.enchantLevel}_${it.serverId}` })}>
                    <img className="thumb" alt={it.itemName} src={it.image} onError={(e) => (e.currentTarget.src = getDefalutImgUrl())} />
                    <strong
                        className="name"
                        data-itemgrade={it.grade}
                        data-areas="시세_리스트_아이템_클릭"
                        data-contents={`${it.enchantLevel > 0 ? `+${it.enchantLevel} ` : ''}${it.itemName}`}
                    >
                        {it.enchantLevel > 0 ? `+${it.enchantLevel}` : ''} {it.itemName}
                    </strong>
                </button>
            </div>

            {svrid === 'all' && (
                <div className="tablecell server">
                    {it.serverName}
                    {it.world && ` ${t('price.world')}`}
                </div>
            )}

            <div className="tablecell min-price">
                {it.nowMinUnitPrice > 0 ? (
                    <>
                        {it.world && <i className="ico-world" />}
                        <i className="ico-price" />
                        <strong className="price">{numChangeFn(it.nowMinUnitPrice)}</strong>
                    </>
                ) : (
                    `${t('noti.noitems')}`
                )}
            </div>

            {svrid !== 'all' && (
                <div className="tablecell avg-price">
                    {it.world && <i className="ico-world" />}
                    <i className="ico-price" />
                    <strong className="price">{numChangeFn(it.avgUnitPrice)}</strong>
                </div>
            )}

            <div className="tablecell qty">
                <i className="ico-tradeable" />
                <strong className="qty">{qtity > 99 ? '99+' : qtity}</strong>
                {it.quantity > 0 && (
                    <button
                        className="btn-folder"
                        data-areas="시세_리스트_매물열기_클릭"
                        onClick={() => isopenSet((current) => !current)}
                    />
                )}
            </div>

            <PriceItemStock it={it} isopen={isopen} qtitySet={qtitySet} />
        </div>
    );
};
